import { render, staticRenderFns } from "./WebTwoCourseActionAdd.vue?vue&type=template&id=268d7897&scoped=true&"
import script from "./WebTwoCourseActionAdd.vue?vue&type=script&lang=js&"
export * from "./WebTwoCourseActionAdd.vue?vue&type=script&lang=js&"
import style0 from "./WebTwoCourseActionAdd.vue?vue&type=style&index=0&id=268d7897&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268d7897",
  null
  
)

export default component.exports